import {useEffect, useState} from 'react';
import FilterCarousel, {
  CarouselOption,
} from '../../../../components/FilterCarousel/FilterCarousel';
import {useParamsFilter} from './helpers/useLoanFilters';

export default function LoanCarouselFilter() {
  const {getFilter, setFilter} = useParamsFilter();

  const periodOptions: CarouselOption[] = [
    {value: 'three-months', label: '3 ماهه'},
    {value: 'four-months', label: '4 ماهه'},
    {value: 'five-months', label: '5 ماهه'},
    {value: 'six-months', label: '6 ماهه'},
    {value: 'twelve-months', label: '12 ماهه'},
    {value: 'eighteen-months', label: '18 ماهه'},
    {value: 'twenty-four-months', label: '24 ماهه'},
    {value: 'thirty-months', label: '30 ماهه'},
    {value: 'thirty-six-months', label: '36 ماهه'},
  ];

  const [selectedPeriod, setSelectedPeriod] = useState(
    () => getFilter('repaymentTime') || 'twelve-months',
  );

  useEffect(() => {
    setSelectedPeriod(getFilter('repaymentTime') || 'twelve-months');
  }, [getFilter]);

  const handleChange = (value: string, index: number) => {
    setSelectedPeriod(value);
    setFilter('repaymentTime', value);
  };

  return (
    <div className="mt-4 mb-6" dir="rtl">
      <h2 className="mb-[1rem] text-sm font-medium text-gray-700">
        مدت زمان بازپرداخت
      </h2>
      <FilterCarousel
        options={periodOptions}
        value={selectedPeriod}
        onChange={handleChange}
      />
    </div>
  );
}
